import { render, staticRenderFns } from "./ZlmxForm.vue?vue&type=template&id=1f4357b7"
import script from "./ZlmxForm.vue?vue&type=script&lang=js"
export * from "./ZlmxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports